import { render, staticRenderFns } from "./reviewResults.vue?vue&type=template&id=32710094&scoped=true&"
import script from "./reviewResults.vue?vue&type=script&lang=js&"
export * from "./reviewResults.vue?vue&type=script&lang=js&"
import style0 from "./reviewResults.vue?vue&type=style&index=0&id=32710094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32710094",
  null
  
)

export default component.exports